// extracted by mini-css-extract-plugin
module.exports = {"title":"label-items_title__3j3Dt headLine-4","item":"label-items_item__2sP03","header":"label-items_header__3B4vB","icon":"label-items_icon__PqUJ3"};